export enum CampaignAlertHistorySource {
  CampaignEditor = 'campaignEditor',
  CampaignIndex = 'campaignIndex',
  CampaignAnalytics = 'campaignAnalytics',
  Homepage = 'homepage',
}
